import { useGame } from "@/hooks/useGame";
import { useTranslation } from "@/hooks/useTranslation";
import { Badge } from "@/components/ui/badge.jsx";
import packageInfo from "../../../package.json";

/**
 * Footer para views autenticadas
 */
function AppFooter() {
  const { t } = useTranslation();
  const { currentSession, activeTables } = useGame();
  const table = activeTables.find((t) => t.id === currentSession?.tableId);

  return (
    <footer
      data-testid="AppFooter-footer"
      className="border-t border-[var(--color-border)] bg-[var(--color-card)] px-4 py-3"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            {table && (
              <>
                <span>
                  {t("footer.playersCount", { count: table.players.length })}
                </span>
                {table.status === "playing" && (
                  <Badge variant="outline">{t("footer.activeGame")}</Badge>
                )}
              </>
            )}
          </div>
          <div className="flex flex-col sm:flex-row items-center space-y-1 sm:space-y-0 sm:space-x-2">
            <p className="text-sm text-[var(--color-muted-foreground)]">
              {t("footer.guildForGlory")}
            </p>
            <Badge variant="outline" className="text-xs">
              {t("footer.version", { version: packageInfo.version })}
            </Badge>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
